import { partialInit } from "../util/partial-init";
import { QuickQuoteResult } from "./quick-quote-result";

export class QuoteModel {

  constructor(public questionnaire: string, data?: Partial<QuoteModel>) {
    partialInit(this, data);
  }

  key: string;
  quoteDate: string;
  parentKey: string;
  sourceUrl: string;
  answers: AnswerModel[];
  result: QuickQuoteResult;
}

export class AnswerModel {
  key: string;
  value: string;

  constructor(key: string, value: string) {
    this.key = key;
    this.value = value;
  }
}
